import * as Sentry from "@sentry/browser";
import { isViewAsTab } from "@helpers/viewAs/viewAsSession";

interface AuthStateSlice {
  auth: { id?: string };
}

interface IdentityStore {
  getState: () => AuthStateSlice;
  subscribe: (listener: () => void) => () => void;
}

// Keeps the Sentry user in sync with auth state so every event (render
// errors included, not just axios errors routed through logException)
// carries who was affected. The id matches invest-api's auth_user_id tag,
// linking web and backend events for the same user. Id only, never email.
// While viewing as an investor events carry a tag instead: the id on screen is not the staff member's.
export const attachSentryIdentitySync = (store: IdentityStore): void => {
  if (isViewAsTab()) {
    Sentry.setTag("view_as", "true");
    Sentry.setUser(null);
    return;
  }

  let sentryUserId: string | undefined;
  const sync = () => {
    const { id } = store.getState().auth;
    if (id === sentryUserId) return;
    sentryUserId = id;
    Sentry.setUser(id ? { id } : null);
  };
  // Sync once at attach time: redux-persist rehydrates auth before this
  // runs, so waiting for the next state change would leave the earliest
  // events of the session anonymous.
  sync();
  store.subscribe(sync);
};
